type GetTotalAndBalanceInput = {
  useCredits?: boolean
  price?: number
  balance?: number
  credits?: number
}

const getTotalAndBalance = ({ useCredits, price, balance, credits }: GetTotalAndBalanceInput) => {
  if (balance) {
    const diffCreditTotal = balance - price
    let creditBalance     = balance
    let creditValue       = 0
    let total             = price


    if (useCredits) {
      creditBalance = diffCreditTotal < 0 ? 0 : Math.abs(diffCreditTotal)
      creditValue   = Math.abs(credits)
      total         = diffCreditTotal >= 0 ? 0 : Math.abs(balance - total)
    }

    return {
      total,
      creditValue,
      creditBalance,
    }
  }

  return {
    total: price,
  }
}


export default getTotalAndBalance
